"use client";

import { Tabs as MantineTabs } from "@mantine/core";
import { TabsProps as MantineTabsProps } from "@mantine/core";
import classes from "./index.module.css";
import { ReactNode } from "react";

interface TabsProps extends MantineTabsProps {
  children: ReactNode;
}

const Tabs = (props: TabsProps) => {
  return <MantineTabs {...props} unstyled classNames={classes} />;
};
export default Tabs;
